import { html, LitElement, } from 'lit-element';
import { css } from 'emotion';

export class StarRating extends LitElement {
  get value() {
    const inputs = this.querySelectorAll(`input`);
    let value = 0;

    inputs.forEach(input => {
      if (input.checked) {
        value = Number(input.value).toFixed(1);
      }
    });

    return value;
  }

  connectedCallback() {
    super.connectedCallback();

    this.uuid = `uuid_` + this.UUIDGeneratorBrowser();
  }

  UUIDGeneratorBrowser() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11)
      .replace(/[018]/g, c =>
        (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
      )
      .replace(/-/g, `_`);
  }

  firstUpdated() {
    this.addEventLabels();
  }

  addEventLabels() {
    const labels = this.querySelectorAll('label');

    labels.forEach(label => {
      label.addEventListener('touchmove', e => {
          const touch = e.touches[0];
          const targetLabel = document.elementFromPoint(touch.clientX, touch.clientY);

          if (!targetLabel || !targetLabel.htmlFor) {
            return;
          }

          const targetInput = this.querySelector(`#${targetLabel.htmlFor}`);
          targetInput.checked = true;

          const myEvent = new CustomEvent('change-event', { 
            detail: {
              value: this.value,
            },
            bubbles: false, 
            composed: true });
          this.dispatchEvent(myEvent);
      });

      label.addEventListener('touchend', e => {        
        const myEvent = new CustomEvent('change-event', { 
          detail: {
            value: this.value,
          },
          bubbles: false, 
          composed: true });
        this.dispatchEvent(myEvent);
      });
    });
    
  }

  createRenderRoot() {
    return this;
  }  
  
  render() {
    return html`
    <div class="${this.basicStyles}">
      <div class="rating">
        <input type="radio" name="${this.uuid}_stars" id="${this.uuid}_star_5" value="5">
        <label for="${this.uuid}_star_5"></label>
        <input type="radio" name="${this.uuid}_stars" id="${this.uuid}_star_4_5" value="4.5">
        <label for="${this.uuid}_star_4_5" class="halfstar"></label>
        <input type="radio" name="${this.uuid}_stars" id="${this.uuid}_star_4" value="4">
        <label for="${this.uuid}_star_4"></label>
        <input type="radio" name="${this.uuid}_stars" id="${this.uuid}_star_3_5" value="3.5">
        <label for="${this.uuid}_star_3_5" class="halfstar"></label>
        <input type="radio" name="${this.uuid}_stars" id="${this.uuid}_star_3" value="3">
        <label for="${this.uuid}_star_3"></label>
        <input type="radio" name="${this.uuid}_stars" id="${this.uuid}_star_2_5" value="2.5">
        <label for="${this.uuid}_star_2_5" class="halfstar"></label>
        <input type="radio" name="${this.uuid}_stars" id="${this.uuid}_star_2" value="2">
        <label for="${this.uuid}_star_2"></label>
        <input type="radio" name="${this.uuid}_stars" id="${this.uuid}_star_1_5" value="1.5">
        <label for="${this.uuid}_star_1_5" class="halfstar"></label>
        <input type="radio" name="${this.uuid}_stars" id="${this.uuid}_star_1" value="1">
        <label for="${this.uuid}_star_1"></label>
        <input type="radio" name="${this.uuid}_stars" id="${this.uuid}_star_0_5" value="0.5">
        <label for="${this.uuid}_star_0_5" class="halfstar"></label>
        <input type="radio" name="${this.uuid}_stars" id="${this.uuid}_star_0" value="0">
        <label for="${this.uuid}_star_0" class="hidden"></label>
      </div>
    </div>
    `;
  }

  get basicStyles() {
    return css`
    @import url(/static/css/font-awesome.css);

    & {
      display: inline-block;
    }

    .wrapper {
      padding: 30px;
      text-align: center;
    }
    
    .rating-container {
      display: inline-block;
      padding: 20px;
      overflow: hidden;
    }

    .rating {
      float: left;

      > input {
        display: none;
      }

      > label {
        float: right;
        color: #ddd;

        &::before {
          display: inline-block;
          padding-right: 5px;
          font-size: 15px;
          font-family: FontAwesome;
          content: '\f005';
        }
      }

      > .halfstar {
        &::before {
          position: absolute;
          padding-right: 0;
          content: "\f089";
        }
      }

      > .hidden {
        &::before {
          width: 5px;
          padding-right: 0;
          visibility: hidden;
        }
      }
    }

    .rating > input:checked ~ label {
      color: #EBBA53;
    }
    `;
  }
}

customElements.define('star-rating', StarRating);